import { GLOBALS } from '../constants/settings';
import Flag from 'global/flag';

class Nav {
  constructor(elems) {
    this.elems = elems;

    this.elems.nav = {
      $top      : document.getElementById('back-to-top'),
      $logout   : document.getElementsByClassName('logout-activate'),
      $header   : document.getElementById('header'),
      $overlay  : document.getElementById('navigation-overlay'),
      $sidenav  : document.getElementById('sidenav'),
    };

    this.elems.nav.$top.addEventListener('click', (e) => {
      this.top(e);
    });


    // refreshes menu state on scroll and resize
    this.menu = {};
    ['scroll', 'resize'].forEach((e) => {
      window.addEventListener(e, (f) => {
        this.menu = this.checkMenu();
        this.checkSidenav();
      });
    });
    this.menuInterval = setInterval(() => {
      this.checkMenu();
    }, GLOBALS.transition);

    this.activators = [].slice.call(document.getElementsByClassName('mobile-menu-activate'));

    this.activators.map((activator, i) => {
      activator.addEventListener('click', (e) => {
        clearInterval(this.menuInterval);
        this.openMenu(true);
      });
    });

    this.closers = [].slice.call(document.getElementsByClassName('mobile-menu-close'));

    this.closers.map((close, i) => {
      close.addEventListener('click', (e) => {
        this.closeMenu();
        this.menuInterval = setInterval(() => {
          this.checkMenu();
        }, GLOBALS.transition);
      });
    });
  }

  checkMenu(override = false, update = true) {
    let lastPos     = (typeof this.menu.lastPos !== 'undefined' && this.menu.lastPos) ? this.menu.lastPos : window.pageYOffset;
    let currentPos  = window.pageYOffset;
    let direction   = (currentPos > lastPos) ? 'down' : 'up';
    let menuOpen    = (direction == 'up' || override) ? true : false;

    if (update) this.updateMenu();

    return {
      isMenuOpen: menuOpen,
      scrollDirection: direction,
      lastPos: currentPos
    }
  }

  updateMenu() {
    if (this.menu.lastPos < 20 || !this.menu.lastPos) {
      this.openMenu();
      this.elems.nav.$header.classList.add('at-top');
    } else {
      this.elems.nav.$header.classList.remove('at-top');
      if (this.menu.isMenuOpen) {
        this.openMenu();
      } else {
        this.closeMenu();
      }
    }
  }

  openMenu(mobile = false) {
    if (mobile) {
      this.elems.nav.$header.classList.add('mobile-menu-open');
      $(this.elems.nav.$overlay).stop(true).fadeIn(GLOBALS.transition);
    } else {
      this.elems.nav.$header.classList.remove('mobile-menu-open');
      $(this.elems.nav.$overlay).hide();
    }
    this.elems.nav.$header.classList.add('menu-open');
  }

  closeMenu() {
    $(this.elems.nav.$overlay).stop(true).fadeOut(GLOBALS.transition);
    this.elems.nav.$header.classList.remove('menu-open');
    this.elems.nav.$header.classList.remove('mobile-menu-open');
  }

  checkSidenav() {
    let scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
    let docHeight = document.body.scrollHeight;
    let footerAd  = (document.getElementById('footer-ad')) ? document.getElementById('footer-ad').clientHeight : 0;
    let footer    = document.getElementById('footer').clientHeight;
    let winHeight = window.innerHeight;

    let footerTop = docHeight - footer - footerAd;
    scrollTop >= footerTop - (winHeight / 2) - 400 ? this.elems.$site.classList.add('sidenav-inactive') : this.elems.$site.classList.remove('sidenav-inactive');

    // back to top
    if (scrollTop >= footerTop - winHeight) {
      this.elems.nav.$top.style.transform    = `translate3d(0,-${scrollTop - (footerTop - winHeight)}px, 0)`;
    } else {
      this.elems.nav.$top.style.transform    = 'translate3d(0,0,0)';
    }
  }

  top(e) {
    $('html, body').animate({
      scrollTop: 0
    }, GLOBALS.transition * 2);
  }
}

export default Nav;



// WEBPACK FOOTER //
// ./app/javascript/global/nav.js